import AbstractStockValue from './abstract-stock-value'

export default class WebStockValue extends AbstractStockValue {
  static get empty(): WebStockValue {
    return new WebStockValue(0)
  }
}
